<template>
  <div class="validator-status-detail">
    <div class="head">
      <div class="arrow-icon" @click="back">
        <img src="../assets/arrow-left.png" />
      </div>
      <div class="icon">
        <img src="../assets/eth.png" />
      </div>
      <div class="title">
        Pool Contract
      </div>

    </div>

    <div class="address-desc">
      Address: <span class="pool" @click="jumpToEtherscan">{{ currentAddress }}</span>
    </div>

    <div class="detail-items">

      <div class="detail-item detail-item1">
          <div class="line-desc">
            Process
          </div>

          <div class="line-content">
            
            <div class="process">
              <div class="process-content">
                <div class="process-title" :class="{'process-active': status >= 0}">
                  <template v-if="currentBalance > 8">
                    Matched
                  </template>
                  <template v-else>
                    Matching
                  </template>
                </div>
              </div>
              <div class="process-content">
                <div class="process-title" :class="{'process-active': status >= 1 && status != 7}">
                  Deposited
                </div>
              </div>
              <div class="process-content">
                <div class="process-title" :class="{'process-active': status >= 2 && status != 7}">
                  Pending
                </div>
              </div>
              <div class="process-content">
                <div class="process-title" :class="{'process-active': status >= 3 && status != 7}">
                  Active
                </div>
              </div>
              <div class="process-content">
                <div class="process-title" :class="{'process-active': status >= 4 && status != 7}">
                  Exit
                </div>
              </div>
            </div>

            <div class="process">
              <div class="process-content2 process-content21">
                <div v-if="status >= 0" class="process-icon">
                   <img src="../assets/active.png" />
                </div>
                <div v-else class="process-gray" />
              </div>
              <div class="line line1" />
              <div class="process-content2">
                <div v-if="status >= 1 && status != 7" class="process-icon">
                   <img src="../assets/active.png" />
                </div>
                <div v-else class="process-gray" />
              </div>
              <div class="line line1" />
              <div class="process-content2">
                <div v-if="status >= 2 && status != 7" class="process-icon">
                   <img src="../assets/active.png" />
                </div>
                <div v-else class="process-gray" />
              </div>
              <div class="line line2" />
              <div class="process-content2">
                <div v-if="status >= 3 && status != 7" class="process-icon">
                   <img src="../assets/active.png" />
                </div>
                <div v-else class="process-gray" />
              </div>
              <div class="line line3" />
              <div class="process-content2">
                <div v-if="status >= 4 && status != 7" class="process-icon">
                   <img src="../assets/active.png" />
                </div>
                <div v-else class="process-gray" />
              </div>
            </div>
            
          </div>

      </div>


      <div class="detail-item">
          <div class="line-desc" :class="{'line-status-desc': status == 3}">
            Status
          </div>

          <div class="line-content">
            <div class="status">
              <div v-if="status == 3" class="status-active">
                <div class="status-icon">
                    <img src="../assets/active.png" />
                </div>
                <div class="status-active-desc">
                  Active
                </div>
              </div>
              <div v-if="status == -2" class="status-desc">
                --
              </div>
              <div v-if="status == -1" class="status-desc">
                Another 24 ETH from Staker need to be deposited
              </div>
              <div v-if="status == 0" class="status-desc">
                <template v-if="currentBalance > 8">
                  Matched
                </template>
                <template v-else>
                  Matching
                </template>
              </div>
              <div v-if="status == 1" class="status-desc">
                Deposited
              </div>
              <div v-if="status == 2" class="status-desc">
                Pending Validator to go live
              </div>
              <div v-if="status == 4 || status == 5" class="status-desc">
                Exit
              </div>
            </div>
            
          </div>
      </div>

      <div class="detail-item">
        <div class="line-desc">
          Current Balance
        </div>

        <div class="line-content">
          <div class="status">
            <div class="status-desc">
              {{ currentBalance }} ETH
            </div>
          </div>
          
        </div>
      </div>

      <div class="detail-item">
        <div class="line-desc">
          Effective Balance
        </div>

        <div class="line-content">
          <div class="status">
            <div class="status-desc">
              {{ effectiveBalance }} ETH
            </div>
          </div>
          
        </div>
      </div>

      <div class="detail-item">
        <div class="line-desc">
          Income
        </div>

        <div class="line-content">
          <div class="income">
            <template 
              v-for="(item, index) in rewardDetails"  >
              <div class="income-item" :key="index">
                <span class="day">{{ item.cycle }}</span>
                <span class="reward">{{ item.reward }} ETH</span>
              </div>
            </template>
            <div class="income-item">
              APR <span class="apr">{{ apr }}</span> (estimated based on the last 7 days)
            </div>
          </div>
          
        </div>
      </div>

      <div class="detail-item">
        <div class="line-desc">
          Eligible for Activation
        </div>

        <div class="line-content">
          <div class="status">
            <div class="status-desc">
              Epoch {{ activationEligibilityEpoch }}
            </div>
          </div>
          
        </div>
      </div>

      <div class="detail-item">
        <div class="line-desc">
          Active since
        </div>

        <div class="line-content">
          <div class="status">
            <div class="status-desc">
              Epoch {{ activationEpoch }}
            </div>
          </div>
          
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import NumberUtil from '../util/numberUtil.js';
import Web3Util from '../util/web3Util.js';
import LocalStorage from '../util/localStorage.js';
import Rpc from '../util/rpc.js';

export default {
  name: 'validatorStake',
  props: {
    poolInfo: {
      type: Object,
      default: function() {
        return { address: '', from: '' };
      }
    }
  },
  data() {
    let from = 'status';
    if (this.poolInfo.from) {
      from = this.poolInfo.from;
    }
    let lang = window.localStorage.getItem('lang');
    return {
      lang: lang,
      from: from,
      currentAddress: this.poolInfo.address,
      status: -2,
      currentBalance: '--',
      effectiveBalance: '--',
      rewardDetails: [
        {
          cycle: '1 day',
          reward: '--'
        },
        {
          cycle: '3 day',
          reward: '--'
        },
        {
          cycle: '7 day',
          reward: '--'
        }
      ],
      apr: '--',
      activationEligibilityEpoch: '--',
      activationEpoch: '--'
    }
  },

  methods: {
    back() {
      this.$emit('validatorDetailBack', this.from);
    },
    jumpToEtherscan() {
      window.open('https://etherscan.io/address/' + this.currentAddress);
    },
    getStakingPoolDetail(pubkey) {
      Rpc.fetchStakingPoolDetail({contract: this.currentAddress, pubkey: pubkey}).then(result => {
        if (result.status == '80000' && result.data) {
          if (result.data.status != 7) {
            this.status = result.data.status;
            this.currentBalance = result.data.currentBalance;
            this.effectiveBalance = NumberUtil.handleEthGweiToFixed(parseFloat(result.data.effectiveBalance));
            this.activationEligibilityEpoch = result.data.activationeligibilityepoch;
            this.activationEpoch = result.data.activeSince;
            this.apr = result.data.apr + '%';

            let income = result.data.income;
            if (income && Array.isArray(income) && income.length > 0) {
              this.rewardDetails = income;
            }
          } else {
            this.status = 1;
            this.currentBalance = '32.00';
            this.effectiveBalance = '32.00';
          }
        } 
      });
    }
  },

  created() {
    let poolPubkey = LocalStorage.getPoolPubKey(this.currentAddress);
    if (poolPubkey) {
      this.getStakingPoolDetail(poolPubkey);
      return;
    }

    let address = ethereum.selectedAddress;
    let web3 = Web3Util.getWeb3();
    let contract = new web3.eth.Contract(Web3Util.getStafiStakingPoolManagerAbi(), Web3Util.getStafiStakingPoolManagerAddress(), {
      from: address
    });
    contract.methods.getStakingPoolPubkey(this.currentAddress).call().then(pubkey => {
      if (pubkey) {
        LocalStorage.setPoolPubKey(this.currentAddress, pubkey);
        this.getStakingPoolDetail(pubkey);
      } else {
        let poolContract = new web3.eth.Contract(Web3Util.getStafiStakingPoolAbi(), this.currentAddress, {
          from: address
        });

        poolContract.methods.getUserDepositBalance().call().then(depositBalance => {
          if (depositBalance == 0) {
            this.status = 0;
            this.currentBalance = '8.00';
            this.effectiveBalance = '8.00';
          } else {
            this.status = 0;
            this.currentBalance = '32.00';
            this.effectiveBalance = '32.00';
          }
        });
      }
    });

  }
};
</script>

<style lang="scss">

.validator-status-detail {

  .head {
    display: flex;
    .arrow-icon {
      cursor: pointer;
      margin-top: 40px;
      margin-right: 20px;
      height: 23px;
      img {
        height: 100%;
      }
    }
    .icon {
      margin-top: 36px;
      margin-right: 10px;
      height: 36px;
      img {
        height: 100%;
      }
    }
  }

  .address-desc {
    padding-left: 48px;
    padding-bottom: 10px;
    margin-top: 10px;
    font-size: 12px;
    border-bottom: 1px solid #474747;
    .pool {
      cursor: pointer;
      color: #00F3AB;
      font-weight: bold;
      text-decoration: underline;
    }
  }

  .detail-items {

    .detail-item {
      margin-top: 20px;
      padding-left: 48px;
      padding-bottom: 10px;
      border-bottom: 1px solid #474747;
      display: flex;

      .line-desc {
        font-size: 12px;
        font-weight: bold;
        width: 115px;
      }

      .line-status-desc {
        line-height: 20px;
      }

      .line-content {
        .process {
          display: flex;

          .process-content {
            margin-right: 20px;

            .process-title {
              font-size: 12px;
              color: #696969;
            }

            .process-active {
              color: #BCBCBC;
            }
          }

          .process-content2 {

            .process-icon {
              margin-top: 7px;
              height: 15px;
              img {
                height: 100%;
              }
            }

            .process-gray {
              margin-top: 7px;
              width: 15px;
              height: 15px;
              border-radius: 50%;
              background: #696969;
            }
          }

          .process-content21 {
            margin-left: 16px;
          }

          .line {
            margin-left: 4px;
            margin-right: 3px;
            height: 1px;
            margin-top: 13px;
            border-bottom: 1px solid #A1A1A1;
          }
          .line1 {
            width: 48px;
          }
          .line2 {
            width: 36px;
          }
          .line3 {
            width: 24px;
          }
        }


        .status {
          
          .status-active {
            display: flex;
            width: 68px;
            height: 20px;
            border-radius: 2px;
            background: #E7F9F6;
            padding-left: 8px;

            .status-icon {
              margin-top: 1px;
              height: 10px;
              img {
                height: 100%;
              }
            }

            .status-active-desc {
              margin-left: 5px;
              color: #00F3AB;
              font-weight: bold;
              font-size: 12px;
              line-height: 20px;
            }

          }

          .status-desc {
            color: #BCBCBC;
            font-size: 12px;
          }

        }

        .income {
          .income-item {
            margin-bottom: 10px;
            font-size: 12px;
            color: #BCBCBC;

            .day {
              margin-right: 6px;
            }
            .reward {
              color: #00F3AB;
            }

            .apr {
              color: #00F3AB;
            }
          }
        }
      }
    }

    .detail-item1 {
      padding-bottom: 20px;
    }
    
  }

}
  
</style>